// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "3265edc3e1f301f8706cca3ef8a59724" + ".css";
};